import React from 'react';
import { Container, Box, Typography, useTheme } from '@mui/material';

const ComingSoon = () => {
  const theme = useTheme();
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '60vh',
          textAlign: 'center',
        }}
      >
        <Typography variant="h2" gutterBottom sx={{ color: theme.palette.text.primary }}>
          Coming Soon!
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mt: 2 }}>
          Stay tuned for updates.
        </Typography>
      </Box>
    </Container>
  );
};

export default ComingSoon;
